<template>
  <v-form>
    <v-container>
      <div style="height: 10px;"></div>
      <v-layout row wrap>
        <v-flex xs12 sm6>
          <v-select
            v-model="selectCategory"
            :items="itemCategories"
            label="商品カテゴリ"
            item-text="itemCategoryName"
            item-value="itemCategoryId"
            :sort-by="['itemCategoryId']"
            :sort-desc="[false]"
            return-object
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs6 sm4>
          <v-switch label="廃番商品も表示する" color="info" value="info" hide-details v-model="dispDeleted"></v-switch>
        </v-flex>
      </v-layout>
      <div style="height: 20px;"></div>

      <v-data-table
        :headers="headers"
        :items="items"
        class="elevation-1"
        hide-actions
        :customFilter="customFilter"
        :search="selectCategory"
        :custom-sort="customSort"
      >
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ props.header.text }}</span>
            </template>
            <span>{{ props.header.text }}</span>
          </v-tooltip>
        </template>
        <template v-slot:items="props">
          
          <!-- 삭제상품표시 스위치가 켜져 있으면 전부 표시하고, 꺼져 있으면 삭제되지 않은 상품(isDeleted === '0')만 표시한다. -->
          <tr
            v-if="dispDeleted === 'info' || (dispDeleted !== 'info' && '0' === props.item.isDeleted)"
            v-bind:class="{
              'deleted-class-name': props.item.isDeleted == '1',
              'changed-class-name': props.item.isChanged && props.item.isDeleted !== '1'
            }"
          >
            <td class="text-xs-left" style="width: 30px;" @click="itemCheck(props.item)">
              <v-checkbox v-model="props.item.isHandling" primary hide-details></v-checkbox>
            </td>
            <td class="text-xs-left">{{ props.item.itemCategoryName }}</td>
            <td class="text-xs-left">{{ props.item.itemName }}</td>
            <td class="text-xs-left">{{ props.item.janCode }}</td>
            <td class="text-xs-right">{{ Number(props.item.unitPrice || 0).toLocaleString() }}</td>
          </tr>
        </template>
      </v-data-table>
      <br />

      <!-- 버튼 영역 -->
      <div class="footer-btns">
        <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
          <v-icon color="black" left>home</v-icon>{{ $t('home-btn') }}
        </v-btn>
        <v-btn block class="ma-2" color="success" @click="forwardStoreItemRegist()" >
          <v-icon dark left>save</v-icon>商品一括登録
        </v-btn>
        <v-btn block class="ma-2" color="error" @click="forwardStoreItemDelete()" >
          <v-icon dark left>save</v-icon>商品一括削除
        </v-btn>
      </div>
    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import axios from 'axios'
export default {
  created() {
    console.log('created')
    this.getAllItems()
  },
  methods: {
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (a.itemCategoryId < b.itemCategoryId) {
          return -1
        } else if (a.itemCategoryId > b.itemCategoryId) {
          return 1
        }
        if (a.itemName < b.itemName) {
          return -1
        } else if (a.itemName > b.itemName) {
          return 1
        }
        return 0
      })
      return items
    },
    onChangeStock(changedItem) {
      console.log('change stock')
      changedItem.isChanged = true
    },
    onChangeOrderLimit(changedItem) {
      console.log('change order limit')
      changedItem.isChanged = true
    },
    getAllItems() {
      console.log('refresh items')
      let thisObj = this

      ServerApiCallService.itemCategories()
        .then(response => {
          console.log('completed item categories')
          thisObj.itemCategories = response.data.itemCategories
          thisObj.itemCategories.unshift({
            itemCategoryId: '#',
            itemCategoryName: '全て'
          })
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })

      ServerApiCallService.items()
        .then(response => {
          thisObj.items = response.data.items
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    customFilter(items, search) {
      if (search.itemCategoryName === '全て') {
        return items
      } else {
        let filteringItems = items.filter(function(value) {
          if (value.itemCategoryId === search.itemCategoryId) {
            return true
          } else {
            return false
          }
        })

        return filteringItems
      }
    },
    itemCheck(itemInfo) {
      let thisObj = this

      if (itemInfo.isChecked) {
        // 체크를 했을때
        itemInfo.isChecked = false;
        for(let i = 0; i < thisObj.selectedItems.length; i++) {
          if(thisObj.selectedItems[i].itemCode === itemInfo.itemCode)  {
              thisObj.selectedItems.splice(i, 1);
            if (i > 0) i--;
          }
        }
      } else {
        // 체크를 지웠을때
        itemInfo.isChecked= true;
        thisObj.selectedItems.push(itemInfo);
      }
    },
    // 상품일괄 등록 버튼을 클릭헸을때
    forwardStoreItemRegist() {
      if (this.selectedItems.length > 0) {
        for (let i=0; i<this.selectedItems.length; i++) {
          // 취급하지 않는 상품을 선택했을대
          if (this.selectedItems[i].itemCategoryId === 18) {
            this.$parent.$parent.$parent.showErrorDialog(
              '廃盤商品は選択できません。'
            )
            return
          }
        }

        // 선택한 상품을 sesseion에 등록
        sessionStorage.setItem("param", JSON.stringify(this.selectedItems));
        // 상품등록 페이지에 이동
        this.$router.push({name: 'admin-store-item-multi-regits'})
      } else {
        // 상품을 선택하지 않았을때
        this.$parent.$parent.$parent.showErrorDialog(
          '商品を選択してください'
        )
        return
      }
    },
    // 상품일괄 등록 버튼을 클릭헸을때
    forwardStoreItemDelete() {
      if (this.selectedItems.length > 0) {
        for (let i=0; i<this.selectedItems.length; i++) {
          // 취급하지 않는 상품을 선택했을대
          if (this.selectedItems[i].itemCategoryId === 18) {
            this.$parent.$parent.$parent.showErrorDialog(
              '廃盤商品は選択できません。'
            )
            return
          }
        }

        // 선택한 상품을 sesseion에 등록
        sessionStorage.setItem("param", JSON.stringify(this.selectedItems));
        // 상품등록 페이지에 이동
        this.$router.push({name: 'admin-store-item-multi-delete'})
      } else {
        // 상품을 선택하지 않았을때
        this.$parent.$parent.$parent.showErrorDialog(
          '商品を選択してください'
        )
        return
      }
    },    
  },
  computed: {
    ...mapState({
      user: state => state.admin
    }),
    selectCategory: {
      get() {
        return this.$store.state.adminSession.selectCategory
      },
      set(value) {
        this.$store.commit('SET_SELECTED_ITEM_CATEGORY', value)
      }
    }
  },
  data() {
    return {
      loader: null,
      dispDeleted: '',
      items: [],
      itemCategories: [],
      selectedItems: [],
      checkbox: null,
      isHandling: true,
      headers: [
        {
          text: '選択',
          align: 'left',
          value: 'selectSupplier',
          width: '30px',
          fixed: true
        },
        {
          text: 'カテゴリ',
          align: 'left',
          value: 'itemCategoryName',
          width: '150px',
          sortable: false
        },
        {
          text: '商品名',
          align: 'left',
          value: 'itemName',
          width: '150px',
          sortable: false
        },
        {
          text: 'JANコード',
          align: 'left',
          value: 'janCode',
          width: '30px',
          sortable: false
        },
        {
          text: '単価',
          align: 'center',
          value: 'unitPrice',
          width: '30px',
          sortable: false
        },
      ]
    }
  }
}
</script>

<style>
.column-input {
  width: 100% !important;
  height: 30px;
  text-align: right;
  border: 1px solid #c7c7c7;
  padding: 0 4px;
}

.deleted-class-name {
  background-color: #b3b3b3;
}
tr.changed-class-name,
.theme--light.v-table
  tbody
  tr.changed-class-name:hover:not(.v-datatable__expand-row) {
  background-color: #ffcccc;
}
.footer-btns {
  position: sticky;         /* 스크롤해도 하단 고정 */
  bottom: 0;                /* 컨테이너의 맨 아래 */
  display: flex;
  justify-content: space-between; /* 버튼 사이 일정 간격 */
  gap: 8px;                 /* 버튼들 사이 여백 */
  width: 100%;              /* 테이블 폭과 동일 */
  background: white;        /* 버튼 뒤 배경 */
  padding: 10px 0;          /* 위아래 여백 */
  z-index: 1000;
}
.footer-btns .v-btn {
  flex: 1;                  /* 버튼들이 같은 폭 */
}
</style>
